<template>
    <div :style="{ 'background-color': backgroundColor}" class="webshop-filter mt-8 px-4" style="position: relative;">
        <div v-if="allCategoriesByRoute.length">
            <div class="pl-3 font-weight-bold primary--text" style="font-size: 20px">Kategori</div>
            <v-list>
                <v-list-group
                    v-for="item in allCategoriesByRoute"
                    v-if="item.count && item.children.length"
                    :key="item.title"
                    :value="categorySelected(item)"
                    append-icon=""
                    no-action>
                    <template v-slot:activator>
                        <v-list-item-action>
                            <v-checkbox :input-value="categorySelected(item)"
                                        color="primary"
                                        hide-details
                                        readonly
                                        @click.stop="selectMainCategory(item)"></v-checkbox>
                        </v-list-item-action>

                        <v-list-item-content>
                            <v-list-item-title class="">
                                {{ item.title }}
                            </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action-text v-if="item.count">
                            <v-list-item-title>
                                <b>({{ item.count }})</b>
                            </v-list-item-title>
                        </v-list-item-action-text>
                    </template>

                    <v-list-item-group class="pl-6" multiple>
                        <v-list-item
                            v-for="subItem in item.children"
                            v-if="subItem.count"
                            :key="subItem.title"
                            @click="selectCategory(subItem, item)">
                            <template v-slot:default="{ active }">
                                <v-list-item-action>
                                    <v-checkbox :input-value="categorySelected(subItem)"
                                                color="primary"
                                                hide-details
                                                readonly></v-checkbox>
                                </v-list-item-action>

                                <v-list-item-content>
                                    <v-list-item-title class="">
                                        {{ subItem.title }}
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action-text v-if="subItem.count">
                                    <v-list-item-title>
                                        <b v-if="subItem.count">({{ subItem.count }})</b>
                                    </v-list-item-title>
                                </v-list-item-action-text>
                            </template>
                        </v-list-item>
                    </v-list-item-group>
                </v-list-group>

                <v-list-item v-else
                             link
                             @click="selectCategory(item)">
                    <v-list-item-action>
                        <v-checkbox :input-value="categorySelected(item)"
                                    color="primary"
                                    hide-details
                                    readonly></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                        <v-list-item-title class="">
                            {{ item.title }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action-text v-if="item.count">
                        <v-list-item-title>
                            <b>({{ item.count }})</b>
                        </v-list-item-title>
                    </v-list-item-action-text>
                </v-list-item>
            </v-list>
        </div>

        <div v-if="sitesFilter.length">
            <div class="pl-3 font-weight-bold primary--text mt-5" style="font-size: 20px">På lager i salong</div>
            <v-list no-action>
                <v-list-item v-for="item in sitesFilter"
                             :key="item.id">
                    <v-list-item-action>
                        <v-checkbox :input-value="urlSites.includes(item.id)"
                                    color="primary"
                                    hide-details
                                    readonly
                                    @click.stop="selectSite(item.id)"></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                        <v-list-item-title class="">
                            {{ item.name }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action-text v-if="item.count">
                        <v-list-item-title>
                            <b>({{ item.count }})</b>
                        </v-list-item-title>
                    </v-list-item-action-text>
                </v-list-item>
            </v-list>
        </div>

        <div v-if="brandsFilter.length">
            <div class="pl-3 font-weight-bold primary--text mt-5" style="font-size: 20px">Merker og serier</div>
            <v-list-group
                append-icon=""
                v-for="item in brandsFilter"
                :key="item.id.Base64Guid"
                :value="brandSelected(item)"
                no-action>
                <template v-slot:activator>
                    <v-list-item-action>
                        <v-checkbox :input-value="brandSelected(item)"
                                    color="primary"
                                    hide-details
                                    readonly
                                    @click.stop="selectBrand(item)"></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content>
                        <v-list-item-title class="text-capitalize">
                            {{ item.title.toLowerCase() }}
                        </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action-text v-if="item.count">
                        <v-list-item-title>
                            <b>({{ item.count }})</b>
                        </v-list-item-title>
                    </v-list-item-action-text>
                </template>

                <v-list-item-group class="pl-6" multiple>
                    <v-list-item
                        v-for="subItem in item.children"
                        :key="subItem.id.Base64Guid"
                        @click.stop="selectSerie(subItem.id.Base64Guid, item.id.Base64Guid)">
                        <template v-slot:default="{ active }">
                            <v-list-item-action>
                                <v-checkbox :input-value="urlSeries.includes(subItem.id.Base64Guid)"
                                            color="primary"
                                            hide-details
                                            readonly/>
                            </v-list-item-action>

                            <v-list-item-content>
                                <v-list-item-title class="text-capitalize">
                                    {{ subItem.title.toLowerCase() }}
                                </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-action-text v-if="subItem.count">
                                <v-list-item-title>
                                    <b>({{ subItem.count }})</b>
                                </v-list-item-title>
                            </v-list-item-action-text>
                        </template>
                    </v-list-item>
                </v-list-item-group>
            </v-list-group>
        </div>
        <v-divider class="horizontal__divider" vertical/>
    </div>
</template>

<script>
import {strNormalize} from '@/utils/fn';
import webshopMixins from '@/components/webshop/cart/webshop.mixins.js'
import {cloneDeep, orderBy} from 'lodash';

export default {
    mixins: [webshopMixins],
    props: ['backgroundColor'],
    data: () => ({
        settings: null,
        allSites: [],
        allCategories: [],
        selectedCategories: [],
        selectedSites: [],
        allBrands: [],
        selectedBrandsAndSeries: [],
    }),
    methods: {
        productsWithAllFiltersExceptExcluded(exclude) {
            const category = typeof this.$route.query.category === 'string' ? [parseInt(this.$route.query.category)] : (this.$route.query.category || []).map(x => parseInt(x));
            const serie = typeof this.$route.query.serie === 'string' ? [this.$route.query.serie] : (this.$route.query.serie || []).map(x => x);
            const site = typeof this.$route.query.site === 'string' ? [parseInt(this.$route.query.site)] : (this.$route.query.site || []).map(x => parseInt(x));

            return this.products
                .filter(x => exclude === 'category' || !category || !category.length || category.includes(x.categoryId)) // filter by category
                .filter(x => exclude === 'serie' || !serie || !serie.length || serie.includes(strNormalize(x.serieName.toLowerCase()))) // filter by series
                .filter(x => exclude === 'site' || !site || !site.length || site.some(r => x.siteIds.includes(r))) // filter by sites
        }
    },
    computed: {

        brandChildSelectedCount() {
            return brand => brand.children.filter(x => this.urlSeries.includes(x.id)).length
        },

        categoryChildSelectedCount() {
            return category => category.children.filter(x => this.urlSeries.includes(x.id)).length
        },

        brandSelected() {
            return item => this.urlBrands.includes(item.id.Base64Guid) || item.children.some(x => this.urlSeries.includes(x.id.Base64Guid))
        },

        categorySelected() {
            return item => (this[item.id ? 'urlCategories' : 'urlMainCategories'].includes(item.id || item.urlSafeName) || this[item.id ? 'urlCategories' : 'urlMainCategories'].includes(item.title.toLowerCase())) || item.children.some(x => this.urlCategories.includes(x.id))
        },

        productsCategories() {
            return this.productsWithAllFiltersExceptExcluded('category').map(x => x.categoryId)
        },

        productsSeries() {
            return this.productsWithAllFiltersExceptExcluded('serie').map(x => x.serieName)
        },

        productsSites() {
            return this.productsWithAllFiltersExceptExcluded('site').map(x => x.siteIds);
        },

        existingSites() {
            this.allSites.forEach(x => x.count = this.products.filter(p => p.siteIds.includes(x.siteId)).length);
            return this.allSites
        },

        existingCategories() {
            let productsCategories = [...new Set(this.productsCategories)]; // remove category id duplicates
            let allCategoriesByRoute = cloneDeep(this.allCategoriesByRoute);
            if (this.$route.params.categorySecond) {
                return allCategoriesByRoute.filter(c => {
                    c.count = this.productsCategories.filter(x => x === c.webshopCategoryId).length;
                    return productsCategories.includes(c.webshopCategoryId)
                });
            } else if (this.$route.params.categoryFirst) {
                allCategoriesByRoute.forEach(category => {
                    category.count = 0;
                    category.children = category.children.filter(c => {
                        c.count = this.productsCategories.filter(x => x === c.webshopCategoryId).length;
                        category.count += c.count;
                        return productsCategories.includes(c.webshopCategoryId)
                    })
                });
                return allCategoriesByRoute.filter(x => x.children.length);
            }
            return []
        },

        existingSeries() {
            let productsSeries = [...new Set(this.productsSeries)]; // remove series duplicates

            let brands = cloneDeep(this.allBrands);
            brands.forEach(category => {
                category.count = 0;
                category.children = category.children.filter(c => {
                    c.count = this.productsSeries.filter(x => x === c.title).length;
                    category.count += c.count;
                    return productsSeries.includes(c.title)
                }).sort((a, b) => (a.title.toUpperCase() > b.title.toUpperCase()) ? 1 : ((b.title.toUpperCase() > a.title.toUpperCase()) ? -1 : 0))
            });
            return brands.filter(x => x.children.length)
                .sort((a, b) => (a.title.toUpperCase() > b.title.toUpperCase()) ? 1 : ((b.title.toUpperCase() > a.title.toUpperCase()) ? -1 : 0))
        },

    },
    watch: {
        brandsFilter: {
            handler(val) {
                if (!this.$route.serie && !this.$route.brand) return;
                let allBrands = val;
                let filteredBrands = this.urlBrands.filter(id => allBrands.map(x => x.id.Base64Guid).indexOf(id) > -1);

                let allSeries = val.map(x => x.children).flat();
                let filteredSeries = this.urlSeries.filter(id => allSeries.map(x => x.id.Base64Guid).indexOf(id) > -1);
                if (allSeries.length !== filteredSeries.length || allBrands.length !== filteredBrands.length) {
                    this.$router.replace({
                        query: {
                            ...JSON.parse(JSON.stringify(this.$route.query)),
                            serie: filteredSeries,
                            brand: filteredBrands,
                            page: 1
                        }
                    }).catch(() => {
                    })
                }
            }, immediate: true
        },
        allCategoriesByRoute: {
            handler(val) {
                // let allSeries = val.map(x => x.children).flat();
                // let filteredSeries = this.urlSeries.filter(id => allSeries.map(x => x.id.Base64Guid).indexOf(id) > -1);
                // if (allSeries.length !== filteredSeries.length)
                //    this.$router.replace({
                //       query: {
                //          ...JSON.parse(JSON.stringify(this.$route.query)),
                //          serie: filteredSeries,
                //          page: 1
                //       }
                //    }).catch(() => {
                //    })
            }, immediate: true
        },
    },
}
</script>

<style lang="scss" scoped>
.v-list-group::v-deep {
    .v-list-item__title {
        font-size: 14px !important;
    }

    .v-input--selection-controls__ripple {
        opacity: 0;
    }

    .v-list-item {
        min-height: unset !important;
    }

    .v-list-item__action {
        margin-right: 5px !important;
        margin-top: 0;
        margin-bottom: 0;
    }

    .v-list-item__content {
        padding: 5px 0;
    }
}

.v-list::v-deep {
    padding: 5px 0;

    .v-list-item__title {
        font-size: 14px !important;
    }

    .v-list-item {
        min-height: unset !important;
    }

    .v-input--selection-controls__ripple {
        opacity: 0;
    }

    .v-list-item__content {
        padding: 0;
    }

    .v-list-item__action {
        margin-top: 0;
        margin-bottom: 0;
        margin-right: 5px !important;
    }
}

.horizontal__divider {
    position: absolute;
    top: 0;
    right: 0;
    border-width: 0 2px 0 0;
}

.webshop-filter {
    height: 100%;
    min-width: 330px !important;
}
</style>
